import { LenderAssignmentTitles } from 'types';

export interface ContactAssignmentTableEntity {
  lenderProfileAssignmentTitleId?: string;
  title: LenderAssignmentTitles;
  userProfileId: string | null;
  lenderProfileId: string;
}

export enum DealerManagementTabs {
  DealerManagement = 'dealerManagement',
  Broadcasts = 'broadcasts',
}
